import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Convierte decimal a formato HH:MM
const decimalAHorasMinutos = (decimal) => {
  const horas = Math.floor(decimal);
  const minutos = Math.round((decimal - horas) * 60);
  return `${horas}h ${minutos}m`;
};

export const generarReporteColectivo = (asistencias) => {
  const doc = new jsPDF();

  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('Argent Investments (YOKOMO)', 14, 15);

  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text('Reporte Colectivo de Asistencias', 14, 25);

  const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  const obtenerDiaSemana = (fecha) => diasSemana[fecha.getUTCDay()];

  // Agrupar por cédula
  const asistenciasPorUsuario = {};
  asistencias.forEach((a) => {
    if (!asistenciasPorUsuario[a.cedula]) {
      asistenciasPorUsuario[a.cedula] = {
        nombre: a.nombre,
        registros: [],
      };
    }
    asistenciasPorUsuario[a.cedula].registros.push(a);
  });

  const tableData = [];

  Object.entries(asistenciasPorUsuario).forEach(([cedula, data]) => {
    const registrosPorFecha = {};

    data.registros.forEach((r) => {
      const fecha = new Date(r.fecha_hora);
      const fechaAjustada = new Date(fecha);
      if (fecha.getUTCHours() < 1) {
        fechaAjustada.setUTCDate(fecha.getUTCDate() - 1);
      }

      const fechaClave = `${fechaAjustada.getUTCFullYear()}-${(fechaAjustada.getUTCMonth() + 1)
        .toString()
        .padStart(2, '0')}-${fechaAjustada.getUTCDate().toString().padStart(2, '0')}`;

      if (!registrosPorFecha[fechaClave]) {
        registrosPorFecha[fechaClave] = [];
      }
      registrosPorFecha[fechaClave].push(r);
    });

    Object.entries(registrosPorFecha).forEach(([fechaClave, registros]) => {
      registros.sort((a, b) => new Date(a.fecha_hora) - new Date(b.fecha_hora));

      for (let i = 0; i < registros.length; i += 2) {
        const entrada = registros[i];
        const salida = registros[i + 1];

        const fecha = new Date(entrada.fecha_hora);
        const diaSemana = obtenerDiaSemana(fecha);
        const fechaStr = `${fecha.getUTCDate().toString().padStart(2, '0')}/${(fecha.getUTCMonth() + 1)
          .toString()
          .padStart(2, '0')}/${fecha.getUTCFullYear()}`;

        const horaEntradaStr = `${fecha.getUTCHours().toString().padStart(2, '0')}:${fecha.getUTCMinutes().toString().padStart(2, '0')}`;

        let horaSalidaStr = '';
        let horasTrabajadas = '';

        if (salida) {
          const horaSalida = new Date(salida.fecha_hora);
          horaSalidaStr = `${horaSalida.getUTCHours().toString().padStart(2, '0')}:${horaSalida.getUTCMinutes().toString().padStart(2, '0')}`;

          const diffMs = horaSalida - fecha;
          const diffHoras = diffMs / (1000 * 60 * 60);
          horasTrabajadas = `${diffHoras.toFixed(2)}h (${decimalAHorasMinutos(diffHoras)})`;
        }

        tableData.push([
          data.nombre,
          diaSemana,
          fechaStr,
          horaEntradaStr,
          horaSalidaStr,
          horasTrabajadas,
        ]);
      }
    });
  });

  autoTable(doc, {
    startY: 35,
    head: [['Empleado', 'Día', 'Fecha', 'Entrada', 'Salida', 'Horas']],
    body: tableData,
  });

  doc.save('reporte_colectivo.pdf');
};
